import { useTranslation } from 'react-i18next';

const LEGEND_ITEMS = [
  { key: 'approved', dotClassName: 'bg-emerald-500' },
  { key: 'pending', dotClassName: 'bg-amber-500' },
  { key: 'today', dotClassName: 'bg-blue-500' },
] as const;

export function CalendarLegend() {
  const { t } = useTranslation('timeOff');

  return (
    <div className="flex flex-wrap items-center gap-4" data-testid="time-off-calendar-legend">
      {LEGEND_ITEMS.map((item) => (
        <div key={item.key} className="flex items-center gap-1.5">
          <span className={`size-2 rounded-full ${item.dotClassName}`} aria-hidden="true" />
          <span className="text-sm text-muted-foreground">{t(`calendar.legend.${item.key}`)}</span>
        </div>
      ))}
    </div>
  );
}
